// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1DA-f","title":"Images90_title__2pcm9","images":"Images90_images__1sjLq"};